/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import {
  Card,
  Box,
  MenuItem,
  Avatar,
  Typography,
  Button,
  Container,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  TextField,
  CircularProgress,
  Menu,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Stack,
  Skeleton,
  Grid,
  Pagination,
  Divider,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import { fDate } from 'utils/formatTime';
import axios, { getErrorMessage } from 'utils/axios';
import CRUD from 'utils/Crud';
import useIsMountedRef from 'hooks/useIsMountedRef';
import useSettings from 'hooks/useSettings';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import Page from 'components/Page';
import ImportCruiseDialog from 'sections/@dashboard/featured-posts/ImportCruiseDialog';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import AppColors from 'utils/AppColors';
import Iconify from 'components/Iconify';

const CATEGORY_OPTIONS = [
  { value: 'joke', label: 'Jokes' },
  { value: 'personal', label: 'Personal' },
  { value: 'motivational', label: 'Motivational' },
  { value: 'harsh', label: 'Harsh' },
  { value: 'very_harsh', label: 'Very Harsh' },
];
const RATING_OPTIONS = [
  { value: '1', label: 'Light' },
  { value: '2', label: 'Hard' },
  { value: '3', label: 'Very Hard' },
  { value: '4', label: 'Extremely Hard' },
];

const CRUISE_TYPES = [
  { value: 'giftcard', label: 'Giftcard' },
  { value: 'crypto', label: 'Crypto' },
  { value: 'general', label: 'General' },
];

function EditCruiseDialog({ open, cruise, onClose, onSave }) {
  const [message, setMessage] = useState(cruise?.message || '');
  const [category, setCategory] = useState(cruise?.category || 'joke');
  const [rating, setRating] = useState(cruise?.rating || '1');
  const [type, setType] = useState(cruise?.type || CRUISE_TYPES[0].value);
  const [saving, setSaving] = useState(false);

  React.useEffect(() => {
    setMessage(cruise?.message || '');
    setCategory(cruise?.category || 'joke');
    setRating(cruise?.rating || '1');
    setType(cruise?.type || CRUISE_TYPES[0].value);
  }, [cruise]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave({
        ...cruise,
        message,
        category,
        rating,
        type,
      });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Cruise</DialogTitle>
      <DialogContent>
        <TextField
          label="Message"
          multiline
          minRows={3}
          fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{ my: 2 }}
        />
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel>Category</InputLabel>
          <Select
            value={category}
            label="Category"
            onChange={(e) => setCategory(e.target.value)}
          >
            {CATEGORY_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* --- Cruise Type --- */}
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel>Type</InputLabel>
          <Select
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value)}
          >
            {CRUISE_TYPES.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel>Rating</InputLabel>
          <Select
            value={rating}
            label="Rating"
            onChange={(e) => setRating(e.target.value)}
          >
            {RATING_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button disabled={saving} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={saving}
          onClick={handleSave}
        >
          {saving ? (
            <CircularProgress color="inherit" size={22} />
          ) : (
            'Save'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}


export default function CruiseManagement() {
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { themeStretch } = useSettings();

  const [data, setData] = useState({
    data: [],
    current_page: 1,
    total_pages: 1,
    total_size: 0,
    page_size: 100,
  });

  const [sort, setSort] = useState({
    page: 1,
    page_size: 100,
    order: 'desc',
    category: '',
    rating: '',
    batch_id: '',
  });

  const [state, setState] = useState({ loading: false, error: null });
  const [batch, setBatch] = useState({ loading: false, data: [] });
  const [importModal, setImportModal] = useState(false);
  const [search, setSearch] = useState({ open: false, query: '', list: [] });
  const [dailog, setDailog] = useState({ open: false, query: '' });
  const [editDialog, setEditDialog] = useState({ open: false, cruise: null });
  const [anchorEls, setAnchorEls] = useState({}); // for menu anchors

  const pageSizes = [100, 250, 500, 1000];

  useEffect(() => {
    getInitData(sort.page);
    getBatchList();
  }, []);

  useEffect(() => {
    getInitData(sort.page);
  }, [sort.page, sort.page_size, sort.category, sort.rating, sort.batch_id]);

  async function getInitData(page = 1) {
    setState({ ...state, loading: true, error: null });
    try {
      let str = `?sort_order=${sort.order}&page=${page}&page_size=${sort.page_size}`;
      str += `&rating=${sort.rating || ''}`;
      str += `&category=${sort.category || ''}`;
      str += `&batch_id=${sort.batch_id || ''}`;

      const res = await axios.get(CRUD.cruise.list + str);
      if (isMountedRef.current) {
        setData(res.data);
        setState({ ...state, loading: false, error: null });
      }
    } catch (error) {
      setState({ ...state, loading: false, error: getErrorMessage(error) });
    }
  }

  async function getBatchList() {
    setBatch({ ...batch, loading: true });
    try {
      const { data: items } = await axios.get(CRUD.cruise.batch);
      setBatch({ loading: false, data: items });
    } catch (e) {
      setBatch({ ...batch, loading: false });
    }
  }

  async function deleteCruise(cruise) {
    Swal.fire({
      text: 'Do you want to delete this Cruise?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: AppColors.DANGER,
      confirmButtonText: 'Yes, continue',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          await axios.delete(`${CRUD.cruise.root}/${cruise.cruise_id}`);
          setData((d) => ({
            ...d,
            data: d.data.filter((e) => e.cruise_id !== cruise.cruise_id),
          }));
          return true;
        } catch (error) {
          Swal.showValidationMessage(getErrorMessage(error));
          return false;
        }
      },
    });
  }

  async function updateCruise(updateCruise) {
    try {
      await axios.put(`${CRUD.cruise.root}/${updateCruise.cruise_id}`, {
        message: updateCruise.message,
        category: updateCruise.category,
        rating: updateCruise.rating,
      });
      setData((d) => ({
        ...d,
        data: d.data.map((item) =>
          item.cruise_id === updateCruise.cruise_id
            ? { ...item, ...updateCruise }
            : item
        ),
      }));
      enqueueSnackbar('Cruise updated successfully!', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(getErrorMessage(e) || 'Error updating cruise', {
        variant: 'error',
      });
      throw e;
    }
  }

  // --- Render ---
  return (
    <Page title="Manage Cruise">
      <Container
        maxWidth={themeStretch ? false : 'lg'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 100px)',
        }}
      >
        <HeaderBreadcrumbs
          heading="Manage Cruise"
          links={[
            { name: 'Cruise center', href: '#' },
            { name: 'Manage' },
          ]}
          action={
            <>
              <Button
                variant="outlined"
                sx={{ mr: 2 }}
                onClick={() => setDailog({ open: true })}
                startIcon={<EditIcon />}
              >
                Search
              </Button>
              <Button
                variant="contained"
                onClick={() => setImportModal(true)}
                startIcon={<EditIcon />}
                sx={{ mr: 2 }}
              >
                Import Batch Cruise
              </Button>
            </>
          }
        />

        <Card
          sx={{
            mt: 2,
            p: 2,
            mb: 4,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minHeight: 0,
          }}
        >
          {/* Filters - Static */}
          <Box sx={{ flexShrink: 0 }}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mb: 3, flexWrap: 'wrap' }}
            >
              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel>Batch</InputLabel>
                <Select
                  value={sort.batch_id}
                  label="Batch"
                  onChange={(e) =>
                    setSort({ ...sort, batch_id: e.target.value, page: 1 })
                  }
                >
                  <MenuItem value="">All Batches</MenuItem>
                  {batch.data.map((opt, i) => (
                    <MenuItem key={i} value={opt.batch_id}>
                      {opt.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel>Category</InputLabel>
                <Select
                  value={sort.category}
                  label="Category"
                  onChange={(e) =>
                    setSort({ ...sort, category: e.target.value, page: 1 })
                  }
                >
                  <MenuItem value="">All Categories</MenuItem>
                  {CATEGORY_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel>Rating</InputLabel>
                <Select
                  value={sort.rating}
                  label="Rating"
                  onChange={(e) =>
                    setSort({ ...sort, rating: e.target.value, page: 1 })
                  }
                >
                  <MenuItem value="">All Ratings</MenuItem>
                  {RATING_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 160 }}>
                <InputLabel>Order</InputLabel>
                <Select
                  value={sort.order}
                  label="Order"
                  onChange={(e) => setSort({ ...sort, order: e.target.value })}
                >
                  <MenuItem value="desc">Newest First</MenuItem>
                  <MenuItem value="asc">Oldest First</MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 130 }}>
                <InputLabel>Rows per page</InputLabel>
                <Select
                  value={sort.page_size}
                  label="Rows per page"
                  onChange={(e) =>
                    setSort({ ...sort, page_size: Number(e.target.value), page: 1 })
                  }
                >
                  {pageSizes.map((sz) => (
                    <MenuItem key={sz} value={sz}>
                      {sz}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ flexGrow: 1 }} />
              <Typography variant="body2" sx={{ color: 'text.secondary', pr: 2 }}>
                {state.loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <>
                    Page {data.current_page} / {data.total_pages} &nbsp; Total:{' '}
                    {data.total_size}
                  </>
                )}
              </Typography>
              <Pagination
                count={data.total_pages || 1}
                page={data.current_page}
                onChange={(e, page) => setSort((s) => ({ ...s, page }))}
                shape="rounded"
                color="primary"
              />
            </Stack>

            {/* Error */}
            {state.error && (
              <Box sx={{ px: 4, py: 2.5, textAlign: 'center', color: 'error.main' }}>
                <Typography variant="h6">Error:</Typography>
                <Typography variant="body2">{state.error}</Typography>
              </Box>
            )}
          </Box>

          {/* Cruise list - Scrollable */}
          <Box
            sx={{
              flexGrow: 1,
              overflowY: 'auto',
              pr: 1, // padding for scrollbar
            }}
          >
            {state.loading ? (
              <Grid container spacing={2}>
                {[...Array(sort.page_size)].map((_, idx) => (
                  <Grid item xs={12} md={6} key={idx}>
                    <Card sx={{ p: 2, minHeight: 175 }}>
                      <Skeleton animation="wave" height={35} width="70%" sx={{ my: 1 }} />
                      <Skeleton animation="wave" height={24} width="50%" />
                      <Skeleton animation="wave" height={18} width="40%" />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container spacing={2} sx={{ minHeight: 'calc(100%)' }}>
                {data.data.length > 0 ? (
                  data.data.map((cruise) => (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={cruise.cruise_id}>
                      <Card
                        sx={{
                          px: 3,
                          py: 3,
                          borderRadius: 3,
                          minHeight: 270,
                          background: 'linear-gradient(145deg, #ffffff, #f9f9fc)',
                          boxShadow: 4,
                          display: 'flex',
                          flexDirection: 'column',
                          position: 'relative',
                          transition: 'transform 0.3s, box-shadow 0.3s',
                          '&:hover': {
                            boxShadow: 10,
                            transform: 'scale(1.03)',
                          },
                        }}
                      >
                        {/* Actions Menu */}
                        <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
                          <IconButton
                            aria-label="More actions"
                            onClick={(e) =>
                              setAnchorEls((a) => ({
                                ...a,
                                [cruise.cruise_id]: e.currentTarget,
                              }))
                            }
                            size="small"
                            sx={{
                              color: 'primary.main',
                              '&:hover': { color: 'primary.dark' },
                              padding: 0, // Avoid extra space around the icon
                            }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEls[cruise.cruise_id]}
                            open={Boolean(anchorEls[cruise.cruise_id])}
                            onClose={() => setAnchorEls((a) => ({ ...a, [cruise.cruise_id]: null }))}
                            PaperProps={{ sx: { minWidth: 160, borderRadius: 1 } }}
                          >
                            <MenuItem
                              onClick={() => {
                                setAnchorEls((a) => ({ ...a, [cruise.cruise_id]: null }));
                                setEditDialog({ open: true, cruise });
                              }}
                            >
                              <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setAnchorEls((a) => ({ ...a, [cruise.cruise_id]: null }));
                                deleteCruise(cruise);
                              }}
                              sx={{ color: 'error.main' }}
                            >
                              <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Delete
                            </MenuItem>
                          </Menu>
                        </Box>

                        {/* Main Message */}
                        <Box sx={{ display: 'flex', alignItems: 'start', gap: 2, mb: 2 }}>
                          <Box sx={{ color: 'primary.light', fontSize: 26 }}>
                            <Iconify icon="mdi:format-quote-open" width={26} />
                          </Box>
                          <Typography
                            variant="body2"
                            sx={{
                              color: 'text.primary',
                              fontWeight: 500,
                              fontSize: '1.1rem',
                              lineHeight: 1.6,
                              wordBreak: 'break-word',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                            }}
                          >
                            {cruise.message}
                          </Typography>
                        </Box>

                        {/* Category, Type & Batch Name - Redesigned */}
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2,
                            color: 'text.secondary',
                          }}
                        >
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              <b>Category:</b>
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary' }}>
                              {CATEGORY_OPTIONS.find((c) => c.value === cruise.category)?.label || cruise.category}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              <b>Type:</b>
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary' }}>
                              {cruise.type || '-'}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              <b>Batch:</b>
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.primary' }}>
                              {cruise.batch_name || '-'}
                            </Typography>
                          </Box>
                        </Box>


                        <Divider sx={{ mb: 2 }} />

                        {/* Footer: Rating & Staff Info */}
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            color: 'text.disabled',
                          }}
                        >
                          {/* Rating */}
                          <Box
                            sx={{
                              px: 2,
                              py: 0.5,
                              borderRadius: 2,
                              fontWeight: 600,
                              fontSize: 14,
                              display: 'flex',
                              alignItems: 'center',
                              bgcolor: (theme) => theme.palette[cruise.rating === '1' ? 'secondary' : cruise.rating === '2' ? 'info' : cruise.rating === '3' ? 'warning' : 'error'].light,
                              color: (theme) => theme.palette[cruise.rating === '1' ? 'secondary' : cruise.rating === '2' ? 'info' : cruise.rating === '3' ? 'warning' : 'error'].dark,
                            }}
                          >
                            <Iconify icon="ph:star-bold" width={16} style={{ marginRight: 6 }} />
                            {RATING_OPTIONS.find((r) => r.value === String(cruise.rating))?.label || cruise.rating}
                          </Box>

                          {/* Staff Name and Date */}
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <Box sx={{ ml: 1 }}>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {cruise.staff_name || '-'}
                              </Typography>
                              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                {fDate(cruise.created_at)}
                              </Typography>
                            </Box>
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                  ))
                ) : (
                  <Grid item xs={12}>
                    <Box sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}>
                      No results.
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
          </Box>
        </Card>

        {/* Dialogs */}
        {editDialog.open && (
          <EditCruiseDialog
            open={editDialog.open}
            cruise={editDialog.cruise}
            onClose={() => setEditDialog({ open: false, cruise: null })}
            onSave={updateCruise}
          />
        )}
        {dailog.open && (
          <SearchQueryDailog
            open={dailog.open}
            hint="Search Database for matching records"
            label="Enter Cruise text"
            handleClose={() => setDailog({ open: false })}
            onSubmit={(val) => {
              setDailog({ open: false });
              setSearch({ open: true, query: val, list: [] });
              // You can add search load here if needed
            }}
          />
        )}
        {importModal && (
          <ImportCruiseDialog
            open={importModal}
            handleClose={() => setImportModal(false)}
            handleComplete={() => {
              setImportModal(false);
              getInitData(sort.page);
            }}
          />
        )}
      </Container>
    </Page>
  );
}
